import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardComponent } from '../../../components/atoms/card/card.component';
import { BadgeComponent } from '../../../components/atoms/badge/badge.component';

@Component({
  selector: 'app-free-features-listing',
  templateUrl: './free-features-listing.component.html',
  styleUrls: ['./free-features-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, CardComponent, BadgeComponent]
})
export class FreeFeaturesListingComponent {}
